var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDynamicChartWidget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 82,
    viewBox: "0 0 124 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_7405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.652 10.0518H5.54614V75.7869H117.652V10.0518Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.652 0.418945H5.54614V10.0517H117.652V0.418945Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.789 37.8463C92.2139 40.0675 98.3819 58.2787 84.2076 57.265C70.6145 56.2963 76.5483 26.515 61.599 27.4431C49.9523 28.164 48.7494 43.4376 38.986 44.0864C24.9468 45.0281 25.92 29.8536 16.3774 29.9527",
    stroke: "#C9C9C9",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3774 23.5322V62.3065",
    stroke: "#C9C9C9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.986 23.5322V62.3065",
    stroke: "#C9C9C9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.599 23.5322V62.3065",
    stroke: "#C9C9C9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2076 23.5322V62.3065",
    stroke: "#C9C9C9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.821 23.5322V62.3065",
    stroke: "#C9C9C9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M37.2423 17.6836H5.54614V39.1883H37.2423V17.6836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M53.8045 55.9805H22.1083V75.7866H53.8045V55.9805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M96.1381 49.8086H63.9689V75.7873H96.1381V49.8086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M117.652 18.3281H89.2357V29.8622H117.652V18.3281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4987 15.7148H0.842407V37.1385H35.4987V15.7148Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M4.172 31.7952V27.9385L10.0517 24.708L12.8676 28.2539L19.4997 23.5186L22.4012 27.6591L32.1736 21.0586V31.7952H4.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4572 21.6221H4.172V22.6989H10.4572V21.6221Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1469 19.0264H4.172V20.1032H13.1469V19.0264Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2409 52.9932H12.7504V80.8506H51.2409V52.9932Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.469 68.8984H18.175V78.0176H23.469V68.8984Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6588 66.8164H41.3649V78.0126H46.6588V66.8164Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2635 61.6221H25.9695V78.0176H31.2635V61.6221Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1346 56.3408H33.8406V78.0168H39.1346V56.3408Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.158 45.9248H66.127V81.5768H123.158V45.9248Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M84.8699 76.4897C82.3502 76.4924 79.8863 75.7476 77.7899 74.3497C75.6935 72.9517 74.0589 70.9634 73.0928 68.6363C72.1267 66.3091 71.8725 63.7477 72.3624 61.2761C72.8524 58.8044 74.0644 56.5337 75.8451 54.751C77.6259 52.9683 79.8954 51.7539 82.3665 51.2614C84.8376 50.7688 87.3993 51.0202 89.7275 51.9839C92.0557 52.9475 94.0457 54.58 95.4459 56.6749C96.846 58.7698 97.5934 61.2329 97.5934 63.7527C97.5886 67.1269 96.247 70.3618 93.8623 72.7491C91.4776 75.1363 88.2441 76.4813 84.8699 76.4897ZM84.8699 54.4488C83.0299 54.4497 81.2316 54.9961 79.7022 56.019C78.1728 57.0418 76.981 58.4952 76.2775 60.1953C75.574 61.8955 75.3904 63.766 75.7499 65.5705C76.1094 67.375 76.9958 69.0323 78.2972 70.3331C79.5985 71.6338 81.2563 72.5194 83.0609 72.8781C84.8656 73.2367 86.7361 73.0522 88.4358 72.3479C90.1356 71.6435 91.5884 70.451 92.6106 68.9211C93.6327 67.3912 94.1782 65.5926 94.1782 63.7527C94.1758 61.2851 93.1942 58.9193 91.449 57.1749C89.7037 55.4305 87.3375 54.45 84.8699 54.4488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M84.8699 76.4893C81.7546 76.4916 78.7469 75.3501 76.4176 73.2814L78.6929 70.7178C80.3952 72.2258 82.5912 73.0577 84.8654 73.0561L84.8699 76.4893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5934 63.7527H94.1647C94.1612 61.2854 93.1792 58.9204 91.4342 57.1762C89.6891 55.432 87.3236 54.4512 84.8564 54.4488V51.0156C88.2334 51.0192 91.471 52.3623 93.8589 54.7502C96.2468 57.1381 97.5898 60.3757 97.5934 63.7527Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8699 76.49V73.0568C87.3371 73.0544 89.7026 72.0735 91.4476 70.3294C93.1927 68.5852 94.1747 66.2201 94.1782 63.7529H97.5934C97.5898 67.1276 96.2486 70.3632 93.8636 72.7507C91.4787 75.1382 88.2445 76.4828 84.8699 76.49Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.1492 59.6307C85.379 59.6307 85.4466 59.7118 85.4466 59.9371V60.4192C85.8408 60.4615 86.2163 60.6093 86.5335 60.8472C86.8507 61.0851 87.0978 61.4042 87.2488 61.7708C87.366 62.0096 87.3164 62.1358 87.0506 62.2529L86.5685 62.4692C86.3432 62.5773 86.2351 62.5322 86.1179 62.2934C86.0169 62.0494 85.8403 61.8442 85.6141 61.708C85.3878 61.5717 85.1238 61.5116 84.8609 61.5365C84.0229 61.5365 83.6399 61.7843 83.6399 62.343C83.6593 62.5146 83.7377 62.6741 83.8619 62.7941C83.986 62.9142 84.1481 62.9872 84.3202 63.0008C84.553 63.0542 84.7895 63.0903 85.0276 63.1089C85.4732 63.1313 85.9133 63.2178 86.3342 63.3658C86.5453 63.4351 86.7422 63.5419 86.9154 63.6811C87.2612 64.045 87.4491 64.5309 87.438 65.0328C87.438 66.1051 86.7217 66.835 85.4511 67.0197V67.5829C85.4511 67.8082 85.3835 67.8893 85.1538 67.8893H84.6131C84.3878 67.8893 84.3112 67.8082 84.3112 67.5829V67.0828C83.8703 67.0508 83.4484 66.8898 83.0983 66.6198C82.7482 66.3499 82.4853 65.9828 82.3423 65.5644C82.3215 65.5206 82.311 65.4726 82.3115 65.424C82.312 65.3755 82.3235 65.3277 82.3452 65.2843C82.3669 65.2409 82.3982 65.203 82.4368 65.1735C82.4753 65.1439 82.52 65.1236 82.5676 65.1139L83.0497 64.9382C83.2975 64.8481 83.4056 64.9066 83.5002 65.1544C83.6001 65.4191 83.7844 65.6433 84.0248 65.7924C84.2651 65.9415 84.5479 66.0071 84.8294 65.9789C85.7305 65.9789 86.181 65.6951 86.181 65.1139C86.1889 64.9797 86.1514 64.8468 86.0746 64.7364C85.9977 64.6261 85.8861 64.5448 85.7575 64.5056C85.4442 64.395 85.1162 64.3312 84.7843 64.3164C84.3324 64.2896 83.8872 64.1939 83.4642 64.0326C83.2579 63.9574 83.066 63.8477 82.8965 63.7082C82.719 63.5321 82.58 63.321 82.4885 63.0883C82.397 62.8556 82.3548 62.6064 82.3648 62.3565C82.3648 61.2932 83.0317 60.5859 84.2932 60.4192V59.9236C84.2932 59.6983 84.3698 59.6172 84.5951 59.6172L85.1492 59.6307Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M117.147 55.9805H101.829V58.4945H117.147V55.9805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M117.129 62.5049H101.811V65.0189H117.129V62.5049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M113.286 69.0107H101.811V71.5248H113.286V69.0107Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.378 14.3047H92.2634V27.7671H121.378V14.3047Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7554 20.2932C97.7109 20.2932 98.4855 19.5186 98.4855 18.5631C98.4855 17.6076 97.7109 16.833 96.7554 16.833C95.7999 16.833 95.0253 17.6076 95.0253 18.5631C95.0253 19.5186 95.7999 20.2932 96.7554 20.2932Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M118.607 17.6836H100.454V19.4452H118.607V17.6836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7554 25.2395C97.7109 25.2395 98.4855 24.4649 98.4855 23.5094C98.4855 22.5539 97.7109 21.7793 96.7554 21.7793C95.7999 21.7793 95.0253 22.5539 95.0253 23.5094C95.0253 24.4649 95.7999 25.2395 96.7554 25.2395Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M118.607 22.627H100.454V24.3886H118.607V22.627Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8043 6.70374C12.6652 6.70374 13.3632 6.0058 13.3632 5.14484C13.3632 4.28388 12.6652 3.58594 11.8043 3.58594C10.9433 3.58594 10.2454 4.28388 10.2454 5.14484C10.2454 6.0058 10.9433 6.70374 11.8043 6.70374Z",
    fill: "#6868FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7919 6.70374C17.6528 6.70374 18.3508 6.0058 18.3508 5.14484C18.3508 4.28388 17.6528 3.58594 16.7919 3.58594C15.9309 3.58594 15.233 4.28388 15.233 5.14484C15.233 6.0058 15.9309 6.70374 16.7919 6.70374Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.775 6.70374C22.6359 6.70374 23.3339 6.0058 23.3339 5.14484C23.3339 4.28388 22.6359 3.58594 21.775 3.58594C20.914 3.58594 20.2161 4.28388 20.2161 5.14484C20.2161 6.0058 20.914 6.70374 21.775 6.70374Z",
    fill: "#24285B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_7405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.549,
    height: 82,
    fill: "white",
    transform: "translate(0.725281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicChartWidget);
export default __webpack_public_path__ + "static/media/dynamic_chart_widget.74400be9de3a433538a01790e77a0b99.svg";
export { ForwardRef as ReactComponent };